import {Component, forwardRef, Input, OnDestroy, OnInit, ViewContainerRef, TemplateRef, ViewChild} from "@angular/core";
import {AbstractControl, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {Subscription} from "rxjs";
import {FormControlBaseComponent} from "../../../../shared/components/form-controls/form-control-base/form-control-base.component";
import {AddToCartFormatModel} from "../../../../shared/models/cart/add-to-cart-format.model";
import {ProductFormatModel} from "../../../../shared/models/product/product-format.model";

@Component({
  selector: "[pcg-ng-product-format]",
  template: require('./product-format.component.html'),
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ProductFormatComponent), multi: true}
    ],
})
export class ProductFormatComponent extends FormControlBaseComponent<AddToCartFormatModel> implements OnDestroy, OnInit {
    @ViewChild("template") public template: TemplateRef<any>;

    private quantityChangedSubscription: Subscription;
    public formControl: AbstractControl = new FormControl(this.DEFAULT_VALUE);

    @Input() public format: ProductFormatModel;
    @Input() public catalogueNumber: string;
    @Input() public productName: string;

    public additionalSuffix: string;

    public constructor(private viewContainerRef: ViewContainerRef) {
        super(new AddToCartFormatModel());

        this.quantityChangedSubscription = this.formControl.valueChanges
            .subscribe(this.handleQuantityChange);
    }

    public ngOnInit(): void {
        this.viewContainerRef.createEmbeddedView(this.template);
        this.handleCustomFormatName();
    }

    private handleCustomFormatName(): void {
        const suffix = "Discs (10 Pack)";
        const name = this.format.name;
        if (name.endsWith(suffix)) {
            this.format.name = name.substring(0, name.length - suffix.length - 1);
            this.additionalSuffix = suffix;
        }
    }

    public outOfStockMessage(): string {
        const href = !!this.format.outOfStockLink
            ? `${this.format.outOfStockLink}?catalogueNumber=${this.catalogueNumber}&productName=${this.productName.replace(" ", "+")}`
            : "";

        return `${this.format.outOfStockMessage} ${!!href ? "<a href=" + href +">Enquire for availability</a>" : ""}`;
    }

    public writeValue(value: any): void {
        super.writeValue(value);
        this.formControl.setValue((value as AddToCartFormatModel).quantity, {emitEvent: false});
    }

    public ngOnDestroy(): void {
        if (this.quantityChangedSubscription) {
            this.quantityChangedSubscription.unsubscribe();
            this.quantityChangedSubscription = null;
        }
    }

    private handleQuantityChange = (quanitity: number) => {
        this.writeNewValue(new AddToCartFormatModel(this.controlValue.id, quanitity));
    }
}
